import axios from "axios";
import { baseUrL, baseUrl, buildQuery,  } from "../config/api-config";
export const hhsFile= "https://erp-hhs.vastedge.com/api";
let cache = new Map();

export async function getTransactionTypes(token, query) {
  try {
    if (cache.has(token))
      return {
        data: cache.get(token),
        error: false,
      };

    const q = buildQuery(query);
    const { data } = await axios.get(`${baseUrl}/transactionTypes${q}`, {
      headers: {
        authorization: token,
      },
    });
    cache.set(token, data);
    return { data, error: false };
  } catch (error) {
    return { error };
  }
}

export function getTransactionTypeDetail(token, query) {
  const q = buildQuery(query);
  return axios.get(`${baseUrl}/transactionTypesfilter${q}`, {
    headers: {
      authorization: token,
    },
  });
}
export function getTransactionTypesap_check(token, query) {
  const q = buildQuery(query);
  return axios.get(`${baseUrl}/transactionTypesap_check${q}`, {
    headers: {
      authorization: token,
    },
  });
}
export function getTransactionTypesap_checkExcelData(token, query) {
  const q = buildQuery(query);
  return axios.get(`${baseUrl}/transactionTypesap_check${q}`, {
    headers: {
      authorization: token,
    },
    responseType: "blob",
  });
}
export function getTransactionTypeDetailExcelData(token, query) {
  const q = buildQuery(query);
  return axios.get(`${baseUrl}/transactionTypesfilter${q}`, {
    headers: {
      authorization: token,
    },
    responseType: "blob",
  });
}

// export function getTransactionDocDetail(token, query) {
//   const q = buildQuery(query);
//   return axios.get(`${baseUrl}/itemdetails${q}`, {
//     headers: {
//       authorization: token,
//     },
//   });
// }
export function getTransactionDocDetail(token, query) {
  const q = buildQuery(query);
  return axios.get(`${baseUrl}/transactionPrimaryDetails${q}`, {
    headers: {
      authorization: token,
    },
  });
}
export function getTransactionSalesOrderDetail(token, query) {
  const q = buildQuery(query);
  return axios.get(`${baseUrl}/salesOrdersdetails${q}`, {
    headers: {
      authorization: token,
    },
  });
}
export function getTransactionDocPurchaseItemDetails(token, query) {
  const q = buildQuery(query);
  return axios.get(`${baseUrl}/purchaseItemDetails${q}`, {
    headers: {
      authorization: token,
    },
  });
}
export function getTransactionDocpurchaseOrderdetails1(token, query) {
  const q = buildQuery(query);
  return axios.get(`${baseUrl}/purchaseOrderdetails${q}`, {
    headers: {
      authorization: token,
    },
  });
}
export function getTransactionDocShippingaddress(token, query) {
  const q = buildQuery(query);
  return axios.get(`${baseUrl}/shippingaddress${q}`, {
    headers: {
      authorization: token,
    },
  });
}
export function getTransactionDoBillingaddress(token, query) {
  const q = buildQuery(query);
  return axios.get(`${baseUrl}/billingaddress${q}`, {
    headers: {
      authorization: token,
    },
  });
}

export function getTransactionItems(token, query) {
  const q = buildQuery(query);
  return axios.get(`${baseUrl}/saleorderItemDetails${q}`, {
    headers: {
      authorization: token,
    },
  });
}
export function getTransactionSalesOrderchannel(token, query) {
  const q = buildQuery(query);
  return axios.get(`${baseUrl}/getChannel${q}`, {
    headers: {
      authorization: token,
    },
  });
}
export function getTransactionBillingAddress(token, query) {
  const q = buildQuery(query);
  return axios.get(`${baseUrl}/billingaddress${q}`, {
    headers: {
      authorization: token,
    },
  });
}
export function getTransactionBillingAddressScheduleTable(token, query) {
  const q = buildQuery(query);
  return axios.get(`${baseUrl}/scheduleTransaction${q}`, {
    headers: {
      authorization: token,
    },
  });
}

export function getTransactionShippingAddress(token, query) {
  const q = buildQuery(query);
  return axios.get(`${baseUrl}/shippingaddress${q}`, {
    headers: {
      authorization: token,
    },
  });
}
export function getTransactionActiveAndWorkFlow(token, query) {
  const q = buildQuery(query);
  return axios.get(`${baseUrl}/ap_checkworkflowDetails${q}`, {
    headers: {
      authorization: token,
    },
  });
}

export function getTransactionAccounting(token, query) {
  const q = buildQuery(query);
  return axios.get(`${baseUrl}/accounting${q}`, {
    headers: {
      authorization: token,
    },
  });
}

export function getTransactionCustom(token, query) {
  const q = buildQuery(query);
  return axios.get(`${baseUrl}/custom${q}`, {
    headers: {
      authorization: token,
    },
  });
}

export function getTransactionCommunication(token, query) {
  const q = buildQuery(query);
  return axios.get(`${baseUrl}/communication${q}`, {
    headers: {
      authorization: token,
    },
  });
}

export function getTransactionMfg(token, query) {
  const q = buildQuery(query);
  return axios.get(`${baseUrl}/mfg${q}`, {
    headers: {
      authorization: token,
    },
  });
}

export function getTransactionGlobalsearch(token, query) {
  const q = buildQuery(query);
  return axios.get(`${baseUrl}/globalsearch${q}`, {
    headers: {
      authorization: token,
    },
  });
}

export function getTransactionEft(token, query) {
  const q = buildQuery(query);
  return axios.get(`${baseUrl}/transactionEFT${q}`, {
    headers: {
      authorization: token,
    },
  });
}

export function getTransactionMessage(token, query) {
  const q = buildQuery(query);
  return axios.get(`${baseUrl}/message${q}`, {
    headers: {
      authorization: token,
    },
  });
}
export function getTransactionCommFiles(token, query) {
  const q = buildQuery(query);
  return axios.get(`${baseUrl}/transactionCommFiles${q}`, {
    headers: {
      authorization: token,
    },
  });
}
export function getTransactionPayeeaddress(token, query) {
  const q = buildQuery(query);
  return axios.get(`${baseUrl}/payeeaddress${q}`, {
    headers: {
      authorization: token,
    },
  });
}

export function getTransactionPartner(token, query) {
  const q = buildQuery(query);
  return axios.get(`${baseUrl}/partner${q}`, {
    headers: {
      authorization: token,
    },
  });
}

export function getTransactionPurchaseItems(token, query) {
  const q = buildQuery(query);
  return axios.get(`${baseUrl}/purchaseItemDetails${q}`, {
    headers: {
      authorization: token,
    },
  });
}

export function getTransactionDocRelatedRecords(token, query) {
  const q = buildQuery(query);
  return axios.get(`${baseUrl}/relatedrecords${q}`, {
    headers: {
      authorization: token,
    },
  });
}
export function getTransactionSalesOrderOpenAir(token, query) {
  const q = buildQuery(query);
  return axios.get(`${baseUrl}/transactionOpenAir${q}`, {
    headers: {
      authorization: token,
    },
  });
}
export function getTransactionSalesOrderTaxAndReporting(token, query) {
  const q = buildQuery(query);
  return axios.get(`${baseUrl}/transactionTaxReporting${q}`, {
    headers: {
      authorization: token,
    },
  });
}
export function getTransactionSalesOrderAvatax(token, query) {
  const q = buildQuery(query);
  return axios.get(`${baseUrl}/transactionAvaTax${q}`, {
    headers: {
      authorization: token,
    },
  });
}
export function getTransactionSalesOrderOptionsAndLogs(token, query) {
  const q = buildQuery(query);
  return axios.get(`${baseUrl}/transactionOptionsLogs${q}`, {
    headers: {
      authorization: token,
    },
  });
}
export function getTransSalesOrderDownloadCommFile(
  token,
  options,
  query,
  filename
) {
  const q = buildQuery(query);
  return axios.post(
    `${hhsFile}/transactionDownloadfile${q}`,
    filename,
    options
    //    {
    //     headers: {
    //       authorization: token,
    //     },
    // responseType: "blob",
    //   }
  );
}
export function getTransactionItemReceiptItemDetails(token, query) {
  const q = buildQuery(query);
  return axios.get(`${baseUrl}/ItemReceiptItemDetails${q}`, {
    headers: {
      authorization: token,
    },
  });
}
export function getTransactionItemfullfillmentItemDetails(token, query) {
  const q = buildQuery(query);
  return axios.get(`${baseUrl}/ItemfullfillmentItemDetails${q}`, {
    headers: {
      authorization: token,
    },
  });
}
export function getTransactionVendorExpenses(token, query) {
  const q = buildQuery(query);
  return axios.get(`${baseUrl}/getExpenses${q}`, {
    headers: {
      authorization: token,
    },
  });
}
export function getTransactionVendorBillItem(token, query) {
  const q = buildQuery(query);
  return axios.get(`${baseUrl}/vendorBillItemDetails${q}`, {
    headers: {
      authorization: token,
    },
  });
}

export function getTransactionVendorBilling(token, query) {
  const q = buildQuery(query);
  return axios.get(`${baseUrl}/billingaddress${q}`, {
    headers: {
      authorization: token,
    },
  });
}
export function getTransactionCustomerPaymentDetail(token, query) {
  const q = buildQuery(query);
  return axios.get(`${baseUrl}/getCustomerPaymentDetails${q}`, {
    headers: {
      authorization: token,
    },
  });
}
export function getTransactionApplied(token, query) {
  const q = buildQuery(query);
  return axios.get(`${baseUrl}/applied${q}`, {
    headers: {
      authorization: token,
    },
  });
}
export function getTransactionCredit(token, query) {
  const q = buildQuery(query);
  return axios.get(`${baseUrl}/creditsApplied${q}`, {
    headers: {
      authorization: token,
    },
  });
}
export function getTransactionCustomerDeposit(token, query) {
  const q = buildQuery(query);
  return axios.get(`${baseUrl}/depositsApplied${q}`, {
    headers: {
      authorization: token,
    },
  });
}
export function getCustomerPaymentMethod(token, query) {
  const q = buildQuery(query);
  return axios.get(`${baseUrl}/transactionPaymentMethod${q}`, {
    headers: {
      authorization: token,
    },
  });
}
export function getTransactionCustomerPaymentEvent(token, query) {
  const q = buildQuery(query);
  return axios.get(`${baseUrl}/transactionPaymentEvent${q}`, {
    headers: {
      authorization: token,
    },
  });
}

export function getTransactionVendorCreditDetails(token, query) {
  const q = buildQuery(query);
  return axios.get(`${baseUrl}/getVendorCreditDetails${q}`, {
    headers: {
      authorization: token,
    },
  });
}

export function getTransactionVendorCreditItemDetails(token, query) {
  const q = buildQuery(query);
  return axios.get(`${baseUrl}/vendorCreditItemDetails${q}`, {
    headers: {
      authorization: token,
    },
  });
}

export function getTransactionVendorCreditApply(token, query) {
  const q = buildQuery(query);
  return axios.get(`${baseUrl}/transactionApply${q}`, {
    headers: {
      authorization: token,
    },
  });
}

export function getTransactionVendorPaymentDetails(token, query) {
  const q = buildQuery(query);
  return axios.get(`${baseUrl}/getVendorPaymentDetails${q}`, {
    headers: {
      authorization: token,
    },
  });
}

export function getTransactionBillPaymentPayeeAddress(token, query) {
  const q = buildQuery(query);
  return axios.get(`${baseUrl}/transactionPayeeaddress${q}`, {
    headers: {
      authorization: token,
    },
  });
}

export function getTransactionVendorPaymentCreditsApplied(token, query) {
  const q = buildQuery(query);
  return axios.get(`${baseUrl}/creditsApplied${q}`, {
    headers: {
      authorization: token,
    },
  });
}

export function getTransactionCreditMemoDetails(token, query) {
  const q = buildQuery(query);
  return axios.get(`${baseUrl}/getCreditMemoDetails${q}`, {
    headers: {
      authorization: token,
    },
  });
}

export function getTransactionCreditCardDetails(token, query) {
  const q = buildQuery(query);
  return axios.get(`${baseUrl}/getCreditCardDetails${q}`, {
    headers: {
      authorization: token,
    },
  });
}


export function getTransactionCreditMemoItem(token, query) {
  const q = buildQuery(query);
  return axios.get(`${baseUrl}/creditmemoitemdetails${q}`, {
    headers: {
      authorization: token,
    },
  });
}

export function getTransactionpurchaseorderitemdetails(token, query) {
  const q = buildQuery(query);
  return axios.get(`${baseUrl}/purchaseorderitemdetails${q}`, {
    headers: {
      authorization: token,
    },
  });
}
export function getTransactionCommonSytemNotes(token, query) {
  const q = buildQuery(query);
  return axios.get(
    `${baseUrl}/transactionSystemNotes${q}`,
    {
      headers: {
        authorization: token,
      },
    }
  );
}

export function getTransactionCustomerRefundDetails(token, query) {
  const q = buildQuery(query);
  return axios.get(`${baseUrl}/getCustomerRefundDetails${q}`, {
    headers: {
      authorization: token,
    },
  });
}

export function getTransactionCommunicationMessage(token, query) {
  const q = buildQuery(query);
  return axios.get(`${baseUrl}/communicationMessage${q}`, {
    headers: {
      authorization: token,
    },
  });
}

export function getTransactionCustomerRefundApplyCredits(token, query) {
  const q = buildQuery(query);
  return axios.get(`${baseUrl}/customerRefundApplyCredits${q}`, {
    headers: {
      authorization: token,
    },
  });
}

export function getTransactionCommunicationMessageAttachments(token, query) {
  const q = buildQuery(query);
  return axios.get(`${baseUrl}/transactionMessagefile${q}`, {
    headers: {
      authorization: token,
    },
  });
}

export function getTransactionCustomerRefundRefundMethod(token, query) {
  const q = buildQuery(query);
  return axios.get(`${baseUrl}/transactionRefundMethod${q}`, {
    headers: {
      authorization: token,
    },
  });
}

export function getTransactionGlImpact(token, query) {
  const q = buildQuery(query);
  return axios.get(`${baseUrl}/transactionGlImpact${q}`, {
    headers: {
      authorization: token,
    },
  });
}

export function getTransactionCurrencyRevaluationDetails(token, query) {
  const q = buildQuery(query);
  return axios.get(`${baseUrl}/getCurrencyRevaluationDetails${q}`, {
    headers: {
      authorization: token,
    },
  });
}

export function getTransactionCurrencyRevRounding(token, query) {
  const q = buildQuery(query);
  return axios.get(`${baseUrl}/getRounding${q}`, {
    headers: {
      authorization: token,
    },
  });
}

export function getTransactionCurrencyRevOtherAccounts(token, query) {
  const q = buildQuery(query);
  return axios.get(`${baseUrl}/getOtherAccounts${q}`, {
    headers: {
      authorization: token,
    },
  });
}

export function getTransactionCurrencyRevOpenPayables(token, query) {
  const q = buildQuery(query);
  return axios.get(`${baseUrl}/getOpenPayables${q}`, {
    headers: {
      authorization: token,
    },
  });
}

export function getTransactionCurrencyRevOpenReceivables(token, query) {
  const q = buildQuery(query);
  return axios.get(`${baseUrl}/getOpenReceivables${q}`, {
    headers: {
      authorization: token,
    },
  });
}

export function getTransactionCurrencyRevRealizedGainLoss(token, query) {
  const q = buildQuery(query);
  return axios.get(`${baseUrl}/getRealizedGainLoss${q}`, {
    headers: {
      authorization: token,
    },
  });
}

export function getTransactionRevenueArrangementDetails(token, query) {
  const q = buildQuery(query);
  return axios.get(`${baseUrl}/getRevenueArrangementDetails${q}`, {
    headers: {
      authorization: token,
    },
  });
}

export function getTransactionRevArrangAllocation(token, query) {
  const q = buildQuery(query);
  return axios.get(`${baseUrl}/getRevArrangAllocationDetail${q}`, {
    headers: {
      authorization: token,
    },
  });
}

export function getTransactionRevArrangRevenueElement(token, query) {
  const q = buildQuery(query);
  return axios.get(`${baseUrl}/getRevArrangRevenueElement${q}`, {
    headers: {
      authorization: token,
    },
  });
}

export function getTransactionRevArrangRevenueFairValueFormula(token, query) {
  const q = buildQuery(query);
  return axios.get(`${baseUrl}/getFairValueFormulaDetails${q}`, {
    headers: {
      authorization: token,
    },
  });
}
export function getTransactionRevArrangRevenueFairValueFormulaSytemNotes(
  token,
  query
) {
  const q = buildQuery(query);
  return axios.get(`${baseUrl}/getFVFSystemNotes${q}`, {
    headers: {
      authorization: token,
    },
  });
}
export function getTransactionRevArrangRevenueRecognitionPlan(token, query) {
  const q = buildQuery(query);
  return axios.get(`${baseUrl}/getRevenueRecognitionPlan${q}`, {
    headers: {
      authorization: token,
    },
  });
}
export function getTransactionRevArrangMessage(token, query) {
  const q = buildQuery(query);
  return axios.get(`${baseUrl}/getRevArrangMessage${q}`, {
    headers: {
      authorization: token,
    },
  });
}

export function getTransactionQuotesEstimateDetails(token, query) {
  const q = buildQuery(query);
  return axios.get(`${baseUrl}/getQuotesestimateDetails${q}`, {
    headers: {
      authorization: token,
    },
  });
}
export function getTransactionRevArrangVersion(token, query) {
  const q = buildQuery(query);
  return axios.get(`${baseUrl}/getRevArrangVersion${q}`, {
    headers: {
      authorization: token,
    },
  });
}

export function getTransactionTransferDetails(token, query) {
  const q = buildQuery(query);
  return axios.get(`${baseUrl}/getTransferDetails${q}`, {
    headers: {
      authorization: token,
    },
  });
}

export function getTransactionUserNotes(token, query) {
  const q = buildQuery(query);
  return axios.get(`${baseUrl}/getUserNotes${q}`, {
    headers: {
      authorization: token,
    },
  });
}
export function getTransactionJPMorganDetails(token, query) {
  const q = buildQuery(query);
  return axios.get(`${baseUrl}/getJPMorganDetails${q}`, {
    headers: {
      authorization: token,
    },
  });
}

export function getTransactionCashSaleDetail(token, query) {
  const q = buildQuery(query);
  return axios.get(`${baseUrl}/getcashsaleDetails${q}`, {
    headers: {
      authorization: token,
    },
  });
}
export function getTransactionApCheckRequest(token, query) {
  const q = buildQuery(query);
  return axios.get(`${baseUrl}/custom/getapcheckrequest${q}`, {
    headers: {
      authorization: token,
    },
  });
}

export function getTransactionItemReceiptDetails(token, query) {
  const q = buildQuery(query);
  return axios.get(`${baseUrl}/getitemreceiptdetails${q}`, {
    headers: {
      authorization: token,
    },
  });
}

export function getTransactionVendorReturnAuthorization(token, query) {
  const q = buildQuery(query);
  return axios.get(`${baseUrl}/getvendorreturnauthorizationdetails${q}`, {
    headers: {
      authorization: token,
    },
  });
}

export function getTransactionItemFulfillment(token, query) {
  const q = buildQuery(query);
  return axios.get(`${baseUrl}/getitemfulfillmentdetails${q}`, {
    headers: {
      authorization: token,
    },
  });
}

export function getTransactionPurchaseOrder(token, query) {
  const q = buildQuery(query);
  return axios.get(`${baseUrl}/getpurchaseorderdetails${q}`, {
    headers: {
      authorization: token,
    },
  });
}

export function getTransactionRevArrangement(token, query) {
  const q = buildQuery(query);
  return axios.get(`${baseUrl}/getRevArrangement${q}`, {
    headers: {
      authorization: token,
    },
  });
}
export function getTransactionCashSaleItemsDetail(token, query) {
  const q = buildQuery(query);
  return axios.get(`${baseUrl}/cashsaleitemdetails${q}`, {
    headers: {
      authorization: token,
    },
  });
}
export function getApchecklistBills(token, query) {
  const q = buildQuery(query);
  return axios.get(`${baseUrl}/ap_checklinkedbills${q}`, {
    headers: {
      authorization: token,
    },
  });
}

export function getApchecklistMessages(token, query) {
  const q = buildQuery(query);
  return axios.get(`${baseUrl}/ap_checkmessages${q}`, {
    headers: {
      authorization: token,
    },
  });
}
export function getRelationshipContactDetails(token, query) {
  const q = buildQuery(query);
  return axios.get(`${baseUrl}/getRelationshipContacts${q}`, {
    headers: {
      authorization: token,
    },
  });
}

